import {combineReducers, createStore, applyMiddleware } from "@reduxjs/toolkit";
import { thunk } from 'redux-thunk'

import chartReducer, {NAME as setup} from './chart-duck.js';

const rootReducer =  combineReducers({
    [setup]: chartReducer,
})

export default createStore(rootReducer, applyMiddleware(thunk))